import { jsx as r } from "react/jsx-runtime";
import * as u from "@radix-ui/react-toggle-group";
import b from "classnames";
import { isValidElement as g, useMemo as T, cloneElement as h } from "react";
import i from "./index.es5579.js";
import { getComponentDisplayName as a } from "./index.es726.js";
import { useScreenZoom as x } from "./index.es589.js";
import { ButtonText as y } from "./index.es506.js";
import { SimpleTooltip as I } from "./index.es127.js";
const S = ({
  size: m,
  item: e,
  disabled: c,
  isActive: s
}) => {
  const { label: o, value: p } = e, t = g(o), n = x().zoomPercentage >= 200, l = c || e.disabled, d = b(i.item, i[`size-${m}`], {
    [i.disabled]: l,
    [i.isLabelIcon]: t
  }), f = T(() => t ? /* @__PURE__ */ r("div", { className: i.iconContainer, children: h(o, {
    color: "outline",
    outline: s ? "white" : "default-gray"
  }) }) : /* @__PURE__ */ r(y, { color: l ? "disabled" : "secondary", isEllipsis: n, children: o }), [l, s, t, n, o]);
  return /* @__PURE__ */ r(
    u.Item,
    {
      value: p,
      className: d,
      "data-testid": `${t ? a(o) : o}-button`,
      disabled: l,
      "pl-identifier": "toggle-button-item",
      "aria-label": t ? a(o) : o,
      children: /* @__PURE__ */ r(
        I,
        {
          title: e.tooltipText,
          isActive: !!e.tooltipText && e.enableTooltip,
          offset: e.tooltipOffset,
          children: f
        }
      )
    }
  );
};
export {
  S as ToggleButtonItem
};
//# sourceMappingURL=index.es769.js.map
